import { LEGENDARY_NAMES } from './lib';

export const SITE = 'https://agentfleet.fun';
const nn = (n) => String(n).padStart(2, '0');
// Per-wallet ref code (same formula as functions/_shared/game.js): AF + first 8 hex chars of the address.
export const refCode = (a) => (a ? `AF${a.slice(2, 10).toUpperCase()}` : '');
// path: /r/<pid>-<block> for an on-chain mint, /r/demo/<spec> for a preview.
export const shareUrl = (path, ship) => `${SITE}${path}${ship ? `?s=${encodeURIComponent(String(ship.id))}` : ''}`;
const tail = (account) => ` @agentfleetbnb #AgentFleet${account ? ` ref ${refCode(account)}` : ''}`;

export function shipText(s, account) {
  if (s.serial) return `🚨 LEGENDARY PULL! Just revealed #${nn(s.serial)} ${LEGENDARY_NAMES[s.serial - 1].toUpperCase()}, 1 of 20 Legendary hulls in AgentFleet 🔥${tail(account)}`;
  return `💜 Epic pull! Just revealed an Epic ${s.kind} in AgentFleet.${tail(account)}`;
}
export function summaryText(ships, account) {
  const lg = ships.filter((s) => s.serial);
  const parts = ['Legendary', 'Epic', 'Rare', 'Common'].map((t) => [t, ships.filter((s) => s.tier === t).length]).filter(([, n]) => n).map(([t, n]) => `${n} ${t}`);
  const head = lg.length ? `🚨 LEGENDARY! Pulled ${lg.map((s) => `#${nn(s.serial)} ${LEGENDARY_NAMES[s.serial - 1]}`).join(' + ')} (1 of 20)` : `Just opened ${ships.length} ship${ships.length > 1 ? 's' : ''}`;
  return `${head} in AgentFleet: ${parts.join(' · ')} 🚀${tail(account)}`;
}
export const intentUrl = (text, url) => `https://x.com/intent/post?text=${encodeURIComponent(`${text}\n${url}`)}`;
